
import { Button } from "@/components/ui/button";
import { useTranslation } from "react-i18next";

interface ScoreButtonProps {
  points: number;
  condition: string;
  onClick: (points: number) => void;
  disabled?: boolean;
}

const ScoreButton = ({ points, condition, onClick, disabled = false }: ScoreButtonProps) => {
  const { t } = useTranslation('training');
  
  const getButtonColor = () => {
    if (points === 6) return "bg-emerald-500 hover:bg-emerald-600";
    if (points === 4) return "bg-green-500 hover:bg-green-600";
    if (points === 3) return "bg-green-500 hover:bg-green-600";
    if (points === 2) return "bg-amber-400 hover:bg-amber-500";
    if (points === 1) return "bg-orange-500 hover:bg-orange-600";
    return "bg-red-500 hover:bg-red-600";
  };

  // Map conditions to translation keys
  const conditionMap: Record<string, string> = {
    "Balle rentrée": "approaches.scoring.ballIn",
    "Balle à moins de 1m": "approaches.scoring.ballLessThan1m",
    "Balle entre 1m et 2m": "approaches.scoring.ballBetween1and2m",
    "Balle au-delà de 2m": "approaches.scoring.ballBeyond2m",
  };

  const translationKey = conditionMap[condition];
  const translatedCondition = translationKey ? t(translationKey) : condition;
  
  const pointsLabel = Math.abs(points) <= 1 ? 'pt' : 'pts';

  return (
    <Button
      onClick={() => onClick(points)}
      className={`h-14 text-base font-medium ${getButtonColor()} text-white border-0`}
      disabled={disabled}
    >
      {translatedCondition} ({points}{pointsLabel})
    </Button>
  );
};

export default ScoreButton;
